import * as React from 'react';
import Box from '@mui/material/Box';
import CustomDataGrid from '../../../../../../Components/CustomDataGrid/CustomDataGrid';

import CustomBackdrop from '../../../../../../Components/CustomBackdrop/Barckdrop';

import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import DataGridCSMSTRIGTH from '../../../../../../PopUp/Components/DataGridCSMSTRIGTH'
import DraggableDialog from '../../../../../../Components/CustomDialogs/DraggableDialog';
import FullScreenDialog from '../../../../../../Components/CustomDialogs/Fullscreendialog';
import filterNonUniqueBy from '../../../../../../CustomFunction/Arraymanage/filterNonUniqueBy';

const columns = [
    { field: 'id', headerName: 'id', width: 0, hide: true },
    {
        field: 'code',
        headerName: 'รหัสพนักงาน',
        width: 200,
        editable: false,

    },
    {
        field: 'nameth',
        headerName: 'ชื่อพนักงาน',
        width: 300,
        editable: false,
        flex: 1
    },
];

const styleMenu = {
    color: "black",
    cursor: "pointer",
    fontFamily: "Customfont !important",
    borderColor: "#bcbcbc",
    backgroundColor: "#bcbcbc",

}

export default function MainData(props) {
    const { defaultData } = props
    const [rows, setRows] = React.useState([])
    const [openbackdrop, setopenbackdrop] = React.useState(false)
    const [openModle, setOpenModle] = React.useState(false)
    const [title, setTitle] = React.useState("เลือกกลุ่มสิทธิ์")
    const [buttontxt, setButtontxt] = React.useState("")

    const [openFullScreenDialog, setopenFullScreenDialog] = React.useState(false)
    const [titleFullScreenDialog, settitleFullScreenDialog] = React.useState("เลือกกลุ่มสิทธิ์")


    React.useEffect(() => {
        setDefaultData()
        return () => {

        }
    }, [])

    const setDefaultData = () => {
        setRows(defaultData)
    }

    const resData = (e) => {
        props.resData(e)
        //setRows(e)
        //  console.log("resData resData", e)
    }
    const removeresData = async (e) => {

        // let arraynewx = await e.filter(valx => {
        //     return !rows.find(valx2 => {
        //         //  console.log("removeresData", val.code + "" === val2.code + "");
        //         return valx.code + "" === valx2.code + ""
        //     })
        // });
        let arr = [...e, ...rows]

        let arrs = await filterNonUniqueBy(arr, (a, b) => a.code == b.code)

        //  await console.log("arrs", arrs);
        await setRows(arrs)


        // if (e.length > 0) {
        //     //setLoadData(true)
        //     if (rows.length > 0) {
        //         // console.log("optionData optionData if case")

        // let array1 = e.filter(val => {
        //     return !rows.find((val2) => {
        //         console.log("array1 filter", val.code + ":" + val2.code);
        //         return val.code + "" === val2.code + ""
        //     })
        // });

        //     } else {
        //         console.log("optionData optionData else case")
        //         array1 = val.filter(val => {
        //             return val
        //         })
        //     }
        // } else {
        //     console.log("optionData val.length else case")
        //     //val.length else case
        //     array1 = []
        // }

        // console.log("array1 row", rows)
        // console.log("array1", array1)
        //  await setRows(array1)

    }
    const selcetRow = (e) => {
        // props.Dataselect(e)
        // console.log("selcetRow", e)
    }
    const resinput = (e) => {
        setInputtext(e)
    }
    const keyDown = (e) => {
        console.log(e);
        if (e === "Enter") {
            loadData("search")
        }
    }
    const selectUser = () => {
        setopenFullScreenDialog(true)
    }
    const customButton = <>
        <Button variant="outlined" startIcon={<GroupAddRoundedIcon />} size="small" onClick={e => selectUser()}
            sx={styleMenu}>
            เลือกกลุ่มสิทธิ์
        </Button>
    </>
    let idCounter = 0;
    const fDataselect = async (e) => {
        setopenFullScreenDialog(false)
        setopenbackdrop(true)
        setTimeout(async () => {
            if (rows.length > 0) {
                const ids = await rows.map(object => {
                    return object.id;
                });
                const max = Math.max(...ids);
                idCounter = max
            }

            console.log("idCounter", idCounter)


            let array1 = await e.filter(val => {
                return !rows.find(val2 => {
                    //  console.log({ valueID: val.code + ":" + val2.id });
                    return val.code.toString() === val2.code.toString()
                })
            });
            console.log(array1)

            if (array1.length > 0) {
                // await setRows([])
                for (let index = 0; index < array1.length; index++) {
                    idCounter += 1;
                    console.log("xxxxxxxxxxxxxxxxxxxxxxxx", e[index].code, ":", e[index].nameth);
                    if ((index + 1) === array1.length) {
                        setopenbackdrop(false)
                    }
                    //count += 1
                    await setRows((prevRows) => [...prevRows, { id: idCounter, code: e[index].code, nameth: e[index].nameth }])
                }
            } else {
                setopenbackdrop(false)
            }
        }, 300);
    }
    const closeDialog = () => {
        // setOpenModle(false)
        setopenFullScreenDialog(false)
    }
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            < CustomDataGrid
                datacolumns={columns}
                datarows={rows}
                rowHeight={35}
                Dataintable={e => resData(e)}
                Dataintableremove={e => removeresData(e)}
                startRow={0}
                option={[{ add: false, del: true, select: false }]}
                checkboxSelection
                Dataselect={e => selcetRow(e)}
                RowsModelChange={_ => console.log("RowsModelChange")}
                customButton={customButton}
            />
            <CustomBackdrop open={openbackdrop} />
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} CloseDialog={_ => closeDialog()}>
                <DataGridCSMSTRIGTH Dataselect={
                    e => fDataselect(e)
                } />
            </FullScreenDialog>
        </Box>
    );
}

